import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Card,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';

const cardStyles = {
  width: '112px'
};

const imageStyles = {
  width: '112px',
  borderTopLeftRadius: '0.4rem',
  borderTopRightRadius: '0.4rem'
};

const labelClasses = classNames(
  'sui-line-clamp-3',
  'sui-font-normal',
  'sui-text-primary',
  'sui-leading-tight',
  'sui-font-regular',
  'sui-text-base',
  'sui-tracking-normal',
  'sui-normal-case'
);

// Constants for label formatting
const MAX_SINGLE_WORD_LENGTH = 11;
const HYPHEN_INSERTION_POSITION = 10;

const formatLabel = (label) => {
  if (!label) return label;

  // Don't format labels that already contain hyphens
  if (label.includes('-')) {
    return label;
  }

  // Split into words to avoid breaking in the middle of multi-word labels
  const words = label.split(' ');

  // If it's multiple words, only format individual long words
  if (words.length > 1) {
    return label;
  }

  // For single words, apply the original logic
  if (label.length > MAX_SINGLE_WORD_LENGTH) {
    return label.substring(0, HYPHEN_INSERTION_POSITION) + '-' + label.substring(HYPHEN_INSERTION_POSITION);
  }

  return label;
};

const ProductCategoryVisNavCard = ({ href, label, src, onClick }) => {
  return (
    <Card
      href={href}
      onClick={onClick}
      CardActionAreaProps={{
        'aria-label': label,
        style: cardStyles
      }}
      disablePadding
      disableGutters
    >
      <CardMedia
        src={src}
        aspect="square"
        alt={label || 'Category image'}
        style={imageStyles}
      />
      <div className="sui-px-2 sui-py-2">
        <CardTitle
          disableTypography
          header={(
            <div className={labelClasses}>
              {formatLabel(label)}
            </div>
          )}
        />
      </div>
    </Card>
  );
};

ProductCategoryVisNavCard.displayName = 'ProductCategoryVisNavCard';

ProductCategoryVisNavCard.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ProductCategoryVisNavCard;
